import * as fromDatatype from '../datatype-library';

export interface bl_fi_pns_settlement_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_ext_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_line_guid: fromDatatype.GuidDataFieldInterface;
  settlement_guid: fromDatatype.GuidDataFieldInterface;
  points_ccy_guid: fromDatatype.GuidDataFieldInterface;
  payment_channel_guid: fromDatatype.GuidDataFieldInterface;
  payment_aggregator_code: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  price_type: fromDatatype.VarcharDatatypeInterface;
  points_currency: fromDatatype.VarcharDatatypeInterface;
  unit_price_selling: fromDatatype.NumericDatatypeInterface;
  unit_price_purchase: fromDatatype.NumericDatatypeInterface;
  selling_unit_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  points_price: fromDatatype.NumericDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;

  reward_type: boolean;
  redeem_type: boolean;
  reward_multiply_rule: boolean;
  reward_abs_rule: boolean;
  redeem_multiply_rule: boolean;
  redeem_abs_rule: boolean;
  reward_abs_amount: fromDatatype.BigIntegerDatatypeInterface;
  reward_multiply_ratio: fromDatatype.BigIntegerDatatypeInterface;
  redeem_abs_amount: fromDatatype.BigIntegerDatatypeInterface;
  redeem_multiply_ratio: fromDatatype.BigIntegerDatatypeInterface;
  reward_point: fromDatatype.VarcharDatatypeInterface;
  validity_period: fromDatatype.NumericDatatypeInterface;
  promo_price: fromDatatype.NumericDatatypeInterface;
  promo_date_from: fromDatatype.TimestampTzDatatypeInterface;
  promo_date_to: fromDatatype.TimestampTzDatatypeInterface;
  description_of_promo: fromDatatype.VarcharDatatypeInterface;
  payment_provider_code:  fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_pns_settlement_link_RowClass implements bl_fi_pns_settlement_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_ext_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_line_guid: fromDatatype.GuidDataFieldInterface;
  settlement_guid: fromDatatype.GuidDataFieldInterface;
  points_ccy_guid: fromDatatype.GuidDataFieldInterface;
  payment_channel_guid: fromDatatype.GuidDataFieldInterface;
  payment_aggregator_code: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  price_type: fromDatatype.VarcharDatatypeInterface;
  points_currency: fromDatatype.VarcharDatatypeInterface;
  unit_price_selling: fromDatatype.NumericDatatypeInterface;
  unit_price_purchase: fromDatatype.NumericDatatypeInterface;
  selling_unit_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  points_price: fromDatatype.NumericDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;

  reward_type: boolean;
  redeem_type: boolean;
  reward_multiply_rule: boolean;
  reward_abs_rule: boolean;
  redeem_multiply_rule: boolean;
  redeem_abs_rule: boolean;
  reward_abs_amount: fromDatatype.BigIntegerDatatypeInterface;
  reward_multiply_ratio: fromDatatype.BigIntegerDatatypeInterface;
  redeem_abs_amount: fromDatatype.BigIntegerDatatypeInterface;
  redeem_multiply_ratio: fromDatatype.BigIntegerDatatypeInterface;
  reward_point: fromDatatype.VarcharDatatypeInterface;
  validity_period: fromDatatype.NumericDatatypeInterface;
  promo_price: fromDatatype.NumericDatatypeInterface;
  promo_date_from: fromDatatype.TimestampTzDatatypeInterface;
  promo_date_to: fromDatatype.TimestampTzDatatypeInterface;
  description_of_promo: fromDatatype.VarcharDatatypeInterface;
  payment_provider_code: fromDatatype.VarcharDatatypeInterface;
}
